import { memo, forwardRef } from 'react'
import type { CommandEntry, CommandOutput } from '../types/commands'

const getOutputClassName = (type: CommandOutput['type']): string => {
  if (type === 'error') return 'command-entry__error'
  return 'command-entry__output'
}

interface CommandHistoryEntryProps {
  entry: CommandEntry
}

const CommandHistoryEntry = memo(
  forwardRef<HTMLDivElement, CommandHistoryEntryProps>(({ entry }, ref) => (
    <div ref={ref} className="command-entry" role="article">
      <div className="command-entry__input" aria-label="Command input">
        <span className="prompt" aria-hidden="true">$</span>
        <span className="sr-only">Command: </span>
        {entry.input}
      </div>
      {entry.output.map((out, j) => (
        <div
          key={j}
          className={getOutputClassName(out.type)}
          role={out.type === 'error' ? 'alert' : 'status'}
          aria-live={out.type === 'error' ? 'assertive' : 'polite'}
          aria-label={`Command output: ${out.type}`}
        >
          {typeof out.content === 'string' ? (
            <pre className="command-output-pre">{out.content}</pre>
          ) : (
            <div className="command-output-pre">{out.content}</div>
          )}
        </div>
      ))}
    </div>
  ))
)

CommandHistoryEntry.displayName = 'CommandHistoryEntry'

export default CommandHistoryEntry
